<script>
  export default {
    name: 'my-apps-list-item',

    props: {
      app: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <tr>
    <th scope="row">
      <img src="/img/apps/cnn_icon.png" alt="" class="app-icon">
      <span>{{ app.application.name }}</span>
    </th>
    <td>
      <span>{{ app.applicationInstances.length }}</span>
    </td>
    <td class="text-right">
      <b-button variant="secondary">Create New</b-button>
    </td>
  </tr>
</template>

<style src="./MyAppsListItem.scss" lang="scss" scoped></style>
